import { render, staticRenderFns } from "./PlatformWithdrawal.vue?vue&type=template&id=5e2dde94"
import script from "./PlatformWithdrawal.vue?vue&type=script&lang=js"
export * from "./PlatformWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports